import * as Yup from 'yup';
import i18n from '../../../../../../translations/strings';
export const ValidationDetailEventFormSchema = (max_attendees: number) =>  Yup.object({
  date: Yup.string().required(i18n.t('booking.errorValidationDate')),
  start: Yup.string().required(i18n.t('booking.timeValidation')),
  end: Yup.string().required(i18n.t('booking.timeValidation')),
  description: Yup.string().required(i18n.t('common.requiredField')),
  attendees: Yup.string().required(i18n.t('common.requiredField')).matches(/^[0-9\b]+$/, i18n.t('common.numberValidation')).test('max_attendees', i18n.t('booking.maxAttendeesValidation'), function (value) {
    if (parseInt(value) > max_attendees) {
      return false;
    }
    return true;
  }),
  layout: Yup.string().required(i18n.t('common.requiredField')),
  payment_method: Yup.string().required(i18n.t('common.requiredField')),
});

export enum TypeClockField {
  Start = 'Start',
  End = 'End',
}
